import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ROUTES } from 'src/navigation';
import { Heading } from '@innovationnorway/cl-react';

const Delivery = () => {
  const { t: tHelpAndSupport } = useTranslation('onboarding');

  return (
    <div className="stack">
      <Heading level={2}>{tHelpAndSupport('commonQuestions.GoalAchievement.Delivery')}</Heading>
      <p>{tHelpAndSupport('commonQuestions.GoalAchievement.Delivery.Deadline')}</p>
      <p>{tHelpAndSupport('commonQuestions.GoalAchievement.Delivery.Text1')}</p>
      <p>{tHelpAndSupport('commonQuestions.GoalAchievement.Delivery.Text2')}</p>
      <p>{tHelpAndSupport('commonQuestions.GoalAchievement.Delivery.Text3')}</p>
      <Link className="display--block" to={ROUTES.SIVA.REPORTING.GOALS.BASE}>
        {tHelpAndSupport('commonQuestions.GoalAchievement.Delivery.Link')}
      </Link>
    </div>
  );
};

export default Delivery;
